/**
 * We're probably using lodash so..
 * @todo check dependencies, import there and
 * remove global, requires removable of inline scripts
 */
import debounce from 'lodash.debounce';

// Expose debounce to the global window object
window.debounce = debounce;

export default debounce; // eslint-disable-line
